var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-info-lottie-banner',[_c('p',{staticClass:"basicInfoIdle__hint"},[_vm._v(_vm._s(_vm.hint))])])
}
var staticRenderFns = []

export { render, staticRenderFns }